module.exports = __webpack_public_path__ + "media/mythra.8baaf47c.wav";